import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./SidebarView.module.scss";
import { IconType, JWayIcon } from "../../../../common/assets/JWayIcons";

export interface SideBarProps {
  buttonList?: NavButtonProps[];
}

/**
 * Side bar view
 *
 * @returns
 */
export default function SidebarView({ buttonList }: SideBarProps) {
  return (
    <div className={styles["sidebar-container-global"]}>
      <div
        className={[
          styles["sidebar-container-global__nav"],
          styles["nav"],
        ].join(" ")}
      >
        {buttonList?.map((button, index) => (
          <div className={styles["nav__btn"]} key={index}>
            <NavButton
              label={button.label}
              onClick={button.onClick}
              iconName={button.iconName}
              regexEqualURL={button.regexEqualURL}
              to={button.to}
              isActive={button.isActive}
              childrensBtn={button.childrensBtn}
            />
          </div>
        ))}
        <div />
      </div>
    </div>
  );
}

/**
 * Nav button props type
 */
export interface NavButtonProps {
  label: string;
  isActive?: boolean;
  to?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  iconName?: IconType;
  colorSet?: ColorSet;
  regexEqualURL?: RegExp;
  childrensBtn?: NavButtonProps[];
  isChild?: boolean;
}

export interface ColorSet {
  color: string;
  colorActive: string;
}
/**
 * Nav button
 *
 * @param param0
 */
export const NavButton = ({
  label,
  isActive: isActiveRaw,
  to,
  onClick,
  icon,
  iconName,
  colorSet = {
    color: "#878686",
    colorActive: "#3B9FB8",
  },
  regexEqualURL,
  childrensBtn,
  isChild,
}: NavButtonProps) => {
  const [isActive, setIsActive] = React.useState(false);

  const location = useLocation();
  const getIsActive = (regex?: RegExp, to?: string) => {
    if (regex) {
      return regex.test(location.pathname);
    }
    if (to) {
      return location.pathname === to;
    }
    return false;
  };
  useEffect(() => {
    setIsActive(getIsActive(regexEqualURL, to));
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if ((isActiveRaw || isActive) && childrensBtn) {
      setOpenDrawer(true);
    } else {
      setOpenDrawer(false);
    }
  }, [isActiveRaw, isActive, childrensBtn, location.pathname]);
  const isActiveTag =
    (isActiveRaw || isActive) && !childrensBtn ? "--active" : "";
  const [openDrawer, setOpenDrawer] = useState(true);

  const getRightSize = (icon: IconType) => {
    switch (icon) {
      case "home":
        return 16;
      case "coin":
        return 20;
      case "electricStation":
        return 16;
      case "peoples":
        return 20;
      case "building":
        return 16;
      case "thunder":
        return 13;
      case "plug-icon":
        return 13;
      default:
        return 16;
    }
  };

  const Content = () => (
    <>
      <div
        style={{
          color:
            isActive && !childrensBtn ? colorSet.colorActive : colorSet.color,
        }}
        className={[
          styles["content-btn"],
          styles["content-btn" + isActiveTag],
        ].join(" ")}
      >
        <div
          style={{
            backgroundColor:
              isActive && !isChild ? colorSet.colorActive : "transparent",
          }}
          className={[styles["content-btn__line"]].join(" ")}
        />
        {icon && (
          <div className={[styles["content-btn__icon"]].join(" ")}>{icon}</div>
        )}
        {iconName && (
          <div className={[styles["content-btn__icon"]].join(" ")}>
            <JWayIcon
              size={getRightSize(iconName)}
              type={iconName}
              color={
                isActive && !childrensBtn
                  ? colorSet.colorActive
                  : colorSet.color
              }
            />
          </div>
        )}

        <span className={[styles["content-btn__label"]].join(" ")}>
          {label}
        </span>
        <div className={[styles["content-btn__end-container"]].join(" ")}>
          {childrensBtn && (
            <div
              className={[
                styles["end-container__icon-arrow"],
                styles["icon-arrow"],
                openDrawer
                  ? styles["icon-arrow--up"]
                  : styles["icon-arrow--down"],
              ].join(" ")}
            >
              <JWayIcon
                size={7.5}
                type={"arrow-right"}
                color={"rgba(135, 134, 134, 0.62)"}
              />
            </div>
          )}
        </div>
      </div>

      {childrensBtn && openDrawer && (
        <div className={styles["drawer"]}>
          <div className={styles["drawer__content"]}>
            {childrensBtn?.map((button, index) => (
              <div key={index} className={styles["drawer-item"]}>
                <NavButton
                  label={button.label}
                  onClick={button.onClick}
                  iconName={button.iconName}
                  regexEqualURL={button.regexEqualURL}
                  to={button.to}
                  isActive={button.isActive}
                  isChild={true}
                  childrensBtn={button.childrensBtn}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <Link className={[styles["link"]].join(" ")} to={to}>
        <Content />
      </Link>
    );
  }

  return (
    <button
      className={[styles["button"]].join(" ")}
      onClick={(e) => {
        e.preventDefault();

        if (childrensBtn) {
          setOpenDrawer(!openDrawer);
          return;
        }
        onClick && onClick();
      }}
    >
      <Content />
    </button>
  );
};
